import { useState } from "react";

const useCheckboxGroup = (initialState) => {
  const [state, setState] = useState([...initialState]);

  return { onChange: setState, state };
};

export { useCheckboxGroup };
